import React from 'react';
import { Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap';
import FlowActions from '../actions/flow';
import '../../css/actionbar.less';

class Actionbar extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ul className="actionbar no-select list-unstyled overflow-y-auto">
                {(this.props.actions || []).map(action => {
                    if  (action.tooltip) {
                        const popover = (
                            <Popover
                                id={action.tooltip.title}
                                className="sidebar-popover"
                            >
                                <h5>{action.tooltip.title}</h5>
                                <div className="popover-content-body">
                                    {action.tooltip.content}
                                </div>
                            </Popover>
                        );

                        return (
                            <OverlayTrigger
                                rootClose={true}
                                trigger={['hover', 'focus']}
                                placement="left"
                                container={this.props.container}
                                overlay={popover}
                                key={action.name}
                            >
                                <li onClick={action.onClick} key={action.name} id={action.name}><Glyphicon glyph={action.icon} /></li>
                            </OverlayTrigger>
                        );
                    }
                    return <li title={action.name} key={action.name} onClick={action.onClick}><Glyphicon glyph={action.icon} /></li>;
                })}
            </ul>
        );
    }

}

export default Actionbar;
